import { getSpacing } from "@faire/web--source/slate/spacing";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

export const ShowMoreCta: React.FC<{
  visibleWhen: boolean;
  onClick: () => void;
}> = ({ visibleWhen, onClick }) => {
  if (!visibleWhen) {
    return null;
  }

  return (
    <InlineCta onClick={onClick}>
      <StrictLocalMsg
        defaultMessage="Show more"
        description={{
          text: "Link/CTA to show more content in the instant answer card",
        }}
      />
    </InlineCta>
  );
};

const InlineCta = styled.span`
  text-decoration: underline;
  cursor: pointer;
  margin-left: ${getSpacing("1x")};
`;
